module.exports = __webpack_public_path__ + "img/gentlemen-club-collection-13.440e50a2.png";